import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Logo from "../../assets/amal-logo-small.png";
import toast from "react-hot-toast";
import { RequestServer } from "../../utils/service";
import { useNavigate } from "react-router-dom";

export default function SignIn() {
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    try {
      const user = await RequestServer("admin/authenticate", "POST", {
        username: data.get("username"),
        password: data.get("password"),
      });
      localStorage.setItem("authToken", user.token);
      const permissions = {
        approve: !!user.response.canApproveOrRejectSwatches ,
        edit: !!user.response.canAddOrEditSwatches,
      }
      localStorage.setItem("permissions", JSON.stringify(permissions));
      navigate("/swatches");
    } catch (error) {
      const errorMsg =
        error?.response?.data?.msg ||
        error.message ||
        "An error occurred while processing your request!";
      toast.error(errorMsg);
    }
  };

  return (
    <div className="search-page-wrapper" style={{ justifyContent: "center" }}>
      <Container
        sx={{ bgcolor: "white", borderRadius: 4 }}
        component="main"
        maxWidth="xs"
      >
        <Box
          sx={{
            py: 4,
            px: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar alt="Amal Logo" src={Logo} sx={{ m: 1 }} />

          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
          </Box>
        </Box>
      </Container>
    </div>
  );
}
